var fontlist = 	['Lilia', 'Tatiana', 'Ludmilla', 'UnitedSansRegBold', 'Racer', 'Phosphate', 'Natalia', 'HeavyDock', 'Simona'];
var fontnames = ['Lilia', 'Tatiana', 'ludmilla', 'nadia', 'nellie', 'yelena', 'natalia', 'melita', 'simona'];
var font_align = [45,42,42.64,45,50,42,42.64,57.69,46.51,50.1,38.18,37.79,39.53,55.88];
var font_align_top = [23.53,11.53,15.79,21.42,23.53,11.53,15.79,21.42,21.74,27.5,10,5,9.09,27.77];
var font_sizes = [100,100];

var is_new = [1,1,0,0];
var ass_url = "https://cdn.shopify.com/s/files/1/2352/1061/t/28/assets/";


var singlets = ["meadow","ocean","bluesky","crisscross","fence","kabel","bliss","forza","cosmos","flourish","tide","radiant","thrive"];

var scolors = ['NAVY#0a2340','ROYAL#2432a4','SKY#65b1eb',
              'RED#cb1828','FUCHSIA#e01697','PINK#f3a7d9',
              'FOREST#12504d','GREEN#228275','LIME#5bd400',
               'ORANGE#f66100','GOLD#b3874b','YELLOW#f8dd00',
               'BLACK#231f20','TITANIUM#54565a','GREY#8a898e',
               'WHITE#ffffff','PURPLE#35009c','MAROON#882630'
              ];
var bindcolors = ['NAVY#0a2340',
                  'ROYAL#2432a4',
                  'OCEAN#00A7E1',
                  'RED#cb1828',
                  'FUCHSIA#e01697',
                  'PURPLE#35009c',
                  'LILAC#A87BC9',
                  'GREEN#228275',
                  'YELLOW#f8dd00',
                  'ORANGE#f66100',
                  'BLACK#231f20',
                  'WHITE#ffffff'];

var meshcolors = ['NAVY#0a2340',
                  'ROYAL#2432a4',
                  'OCEAN#00A7E1',
                  'RED#cb1828',
                  'FUCHSIA#e01697',
                  'PINK#f3a7d9',
                  'TAN#DDBAAD',
                  'GREEN#228275',
                  'YELLOW#f8dd00',
                  'BLACK#231f20',
                  'WHITE#ffffff'];

var fs_on = false;
var picker;
var space = 28;
var curthumbpage = 0;
var maxthumbpage = 0;
var maxneckpage = 0;
var currneckpage = 0;
var currmesh = 0;

var maxblingpage = 0
var currblingpage = 0;
var currbling = 0;
var currbling_style = 9;
var blingstyle = 3; // no bling

let currblingstylepage = 0;
let maxblingstylepage = 0;

var currdesign;
var currcoltab = 0;
var initcolors = ['002700', '00576d', '9ea3a7', '0090a8', 'ffffff', 'ffffff', '033068.50', 'ffffff', 'ffffff'];
var currcolors;

var team_logos = [1,1,0,0];
var currlogos=0;
var hasgrad= 0;
var teamname;

var font_sizes = [34,51];
var font_id = 0;
var team_name = "";
var scw = 0;

var currstyle = 0;
var styles = ['sozleo1103st','sozleo2127st','sozleo2215st','sozleo1927st','sozleo1101','sozleo2075st']
var style_names = ['SOZLEO1103ST','SOZLEO2127ST','SOZLEO2215ST','SOZLEO1927ST','SOZLEO1101','SOZLEO2075ST'];

var currcut = 0;
var cutstyles = ['full', 'dia', 'oval'];

var showbind = 0;



function isOverflowed(element){
    return $(element).children('div').innerWidth() >  $(element).innerWidth();
}


setInterval(function() {

	if(fs_on==true) {
      resizeBuilder(1, 0,'0% 0%');
    } else {
      onPageResize();
    }
})


function onPageResize(){

  scw = 0
  var ww  = $('.wu-wrapper').parent().innerWidth();

  let _tr;

  if(ww<=1024 && fs_on==false){
    sc = ww/1195;
    _tr = '0% 0%';
  }else{
    sc = 0.8;
    _tr = '50% 0%';
  }
  resizeBuilder(sc, scw, _tr);
}

function resizeBuilder(sc, scw, _tr){

    if(fs_on!=true) {
      	$('.wu-wrapper').css({
            'transform-origin':_tr,
            '-webkit-transform-origin':_tr,
            '-moz-transform-origin':_tr,
            '-o-transform-origin':_tr,
            '-ms-transform-origin':_tr,
            'transform':'scale('+sc+')',
            '-webkit-transform':'scale('+sc+')',
            '-moz-transform':'scale('+sc+')',
            '-o-transform':'scale('+sc+')',
            '-ms-transform':'scale('+sc+')',
            'margin-top': '0px'
        });

      $('.wu-container').css({
          'background': 'transparent'
        });
  
      
	$('.wu-wrapper').parent().css({'overflow':'hidden','height':915*sc});
    $('#page').css({'margin-bottom':'-30px'});      
      
      
    } else {

      $('.wu-wrapper').parent().css({'overflow':'hidden','height': '100%'});
      $('#page').css({'margin-bottom':'0px'});

      let fmt = ($('.wu-container').height() - 915)/2;
      console.log(fmt);

      $('.wu-wrapper').css({
            'transform-origin':_tr,
            '-webkit-transform-origin':_tr,
            '-moz-transform-origin':_tr,
            '-o-transform-origin':_tr,
            '-ms-transform-origin':_tr,
            'transform':'scale('+sc+')',
            '-webkit-transform':'scale('+sc+')',
            '-moz-transform':'scale('+sc+')',
            '-o-transform':'scale('+sc+')',
            '-ms-transform':'scale('+sc+')',
            'margin-top': fmt+'px'
        });

        $('.wu-container').css({
          'background': 'white'
        });
      
    }
}

function initSinglets(){
  
  //   meshes
  $('.meshcheck').click(onMeshSelect);
  
  // bindings and neck cut styles
 
  $('.stylecut').click(onCutSelect);
  $('.bindcheck').click(setBinding);
  
  // check fullscreen mode
  
  if(screenfull.isEnabled==true) {

      screenfull.on('change', function() {

          fs_on = screenfull.isFullscreen ?true:false;
          if(fs_on==false) {
              $('.wu-fs-btn').removeClass('on');
              //$('.wu-container').removeClass('fs');
          }


      });

  } else {

      // if device doesnt support fullscreen mode
  }

  
  $('.wu-fs-btn').click(function() {

     if(!$(this).hasClass('on')){
          
         screenfull.request($('.wu-wrapper').parent()[0]);
         $('.wu-fs-btn').addClass('on');
         //$('.wu-container').addClass('fs');

      } else {
         screenfull.exit();
         setTimeout(onPageResize, 500);
      }

  });

  
  $('.share-tab').click(function() {
  	$('.shareform').hide();
    $(this).parent().find('.shareform').slideDown(500);
  })

  $('.wu-grad-flip').click(gradFlip);
  $('.wu-grad-remove').click(checkGradient);

  $(window).bind('resize',onPageResize);
  onPageResize();

	$('#req-date').Zebra_DatePicker({direction:true, format:"m/d/Y",onSelect:onDateSelect,onClear:onDateClear});
	comboBox(fontlist,fontnames,$('#wu-font-select'));

	$('.wu-team-input').on('input',onTeamInput);
  $('#q-team').on('input',function() {
    var _tname = $(this).val().replace(/[^A-Za-z0-9\s]/g, '');
    $(this).val(_tname.toUpperCase());
  })
	$('#q-qty').bind('keyup',calculatePrice);

	/****************************************/

  $('.wu-file-leotard').click(function() {
    $('#q-file1').click();
  })

	picker = $.farbtastic('#wu-picker');
	picker.linkTo(setColorByPicker);

   $('.logochoose').bind('click',onLogChooseClick);
   $('.blingchoose').on('click',setBlingStyle);
   $('#wu-bling-img').hide();

	$('.share-btn').bind('click',shareDesign);
	//$('.tooltipster-icon').tooltipster({touchDevices:true,animation:'grow',speed:150,distance:3});

	$('#team-text').focusin(function(){
		if($('#team-text').val()=='*Separate your teammates emails with a comma'){
			$('#team-text').val('');
		}
	})

	$('#team-text').focusout(function(){
		if($('#team-text').val()==''){
			$('#team-text').val('*Separate your teammates emails with a comma');
		}
	})

	var query = window.location.href.indexOf('#')!=-1?window.location.href.split('#')[1]:window.location.href.split('=')[1]

	if(query==undefined || query==''){

	currdesign = 0;
	currcolors = initcolors;
	team_logos = [1,0,0,0];
    currlogos = 0;
    font_id = 0;
    team_name = "";
    currcut = 0;

	}else{

    dparts = unescape(query).split('/');
      
    currdesign = dparts[0];							      // design id
    currstyle = dparts[1].split('-')[0];			// style
    currcut = dparts[1].split('-')[1];			  // cut

    currcolors = initcolors;
    var s_col= dparts[2].split('-');	        // colors	

    for(i=0;i<s_col.length;i++){
      currcolors[i] = s_col[i];
    }
      
    hasgrad = dparts[3].split('-')[0];
    gflip = dparts[3].split('-')[1];

    currlogos = dparts[4];
    team_name = dparts[5]?decodeURIComponent(dparts[5]):"";
    font_id = dparts[6]?dparts[6]:0;
      
    showbind = Number(dparts[7].split('-')[0]);
    currbling = Number(dparts[7].split('-')[1]);
    blingstyle = Number(dparts[7].split('-')[2]);
    currmesh = Number(dparts[7].split('-')[3]);
    skin_tone = Number(dparts[7].split('-')[4]);
    currbling_style = Number(dparts[7].split('-')[4]);
        
	}

  initQuoteForm();
  gotoTab(0);
  addStockColors();
  createManipulationUI();

  $("#wu-design").svg({loadURL: ass_url+"wu-training-kit.svg?"+new Date().getTime(),
    
    onLoad:function(){
            
        // move back yoke logo
    
        $("#wu-design").animate({opacity:1},700)
        $("#wu-design-bindings").animate({opacity:1},700)
        $('.wu-circle-preloader').fadeOut(700).appendTo('.wu-pop');

        initSkinTone();

        $("#wu-design image").each(function(i, e) {
            var iurl = $(e).attr('xlink:href')
            $(e).attr('xlink:href', ass_url+iurl)
        })

        currcoltab = 0;
        setColor('col1','#'+currcolors[0]);
        currcoltab = 1;
        setColor('col2','#'+currcolors[1]);
        currcoltab = 2;
        setColor('col3','#'+currcolors[2]);
        currcoltab = 3;
        setColor('col4','#'+currcolors[3]);
        currcoltab = 4;
        setColor('col5','#'+currcolors[4]);
        currcoltab = 5;
        setColor('col6','#'+currcolors[5]);


        // zipper
        currcoltab = 7;
        setColor('col8','#'+currcolors[7]);

        // set binding      
        setBindingStyle();
        $('.bindcheck').eq(showbind).click(); 

        // set cut style
        $('.stylecut').eq(currcut).click();

        addNeckStyles();
        addThumbs();
        setLogos();

        // add bling styles
        addBlingStyles();

        //  set mesh      
        $('.meshcheck').eq(currmesh).click();

        // add gradients
         currcoltab = 6;
         addGradient();
       	 initGradientPicker();

        // set bling style
        $('.blingchoose[bstyle="'+blingstyle+'"]').click();

        $('.wu-bl-thumb').eq(currbling).click();

        // used for bling image 
        //if(currbling_style!=9) $('.wu-bling-thumbs .wu-pat-th-sl').eq(currbling_style).click();

        // set team names and fonts
        $('.wu-team-input').val(team_name);
        setTeamName(team_name);
        setTeamFont(font_id);

        // set position to 1st color tab
        currcoltab = 0;
    }
  });      

	$('.wu-menu-btn').bind('click',tabClick);
	$('.wu-tab-header.color-tab').bind('click',colTabClick);
	$('.wu-tab-header.logo-tab').bind('click',logTabClick);
  
	$('.wu-pat-nav-sl .wu-pat-nav-btn').bind('click',thNavClick);
	$('.wu-pat-nav-neck .wu-pat-nav-btn').bind('click',neckNavClick);
  
	$('.wu-pat-nav-bling .wu-pat-nav-btn').bind('click',blingNavClick);
    $('.wu-pat-nav-style-bling .wu-pat-nav-btn').bind('click',blingNavStyleClick);


    $('.wu-pat-nav-color .wu-pat-nav-btn').bind('click',thColClick);
    $('.wu-pat-nav-emb .wu-pat-nav-btn').bind('click',thEmbClick);

	/**** show after loading complete ********/
	var i=0;
	var l=$('#wu-wrapper img').length

	//$('#wu-wrapper img').load(function(){
		//i++
        //console.log(i)
		//if(i==l){
			$('#hider').animate({opacity:0},700,function(){$('#hider').css('display','none')})
		//}
	//})
            
            
     $('.swatch, #wu-picker').click(function() {
       if(currcoltab==6) {
       		gradientOnColorSelect();
       }
     })
     
     
     // init popups
     
     initPop();


}



/****************************************/
/********* menu functions **************/
/****************************************/

function tabClick(){
	var id = $(this).index();
	gotoTab(id);
}

function gotoTab(id){
	var ctab = $('.wu-menu-btn:eq('+id+')');
	$('.wu-menu-btn').removeClass('active');
	$(ctab).addClass('active');
	$('.wu-app-slide-content').stop();
	$('.wu-app-slide-content').animate({top:-id*695},700);

   // click on active tab
   // $('.wu-app-section:eq('+id+') .wu-tab-content.focus').prev().click();


  if(remTimeout!=null) {
    clearTimeout(remTimeout);
  }
  if(id==2 && remtriggered==false) {
    stratRemTimeout();
  }


}

function addBlingStyles() {

	let pagecount = Math.floor(styles.length/3)
	maxblingstylepage = pagecount==styles.length/3?pagecount-1:pagecount;
  
  	if (pagecount>0){
	  $('.wu-page-count-sl.blings').show();
    }else{
      $('.wu-page-count-sl.blings').hide();
    }
  
    $('.wu-page-count-sl.blings').text((currblingstylepage+1)+'/'+(maxblingstylepage+1));
  
  	// if(styles.length>3){
    //   $('.wu-pat-nav-neck .right').show();
    // }
  
  	for (i=0; i<5; i++) {

      var thname = 'BLING#'+(i+1)
      var thurl = ass_url+ 'wu-th-bl'+ (i+1) +'.png?123';
      var thsample = '<div class="wu-pat-th-sl" bstyle="'+i+'"><img src="'+thurl+'" /><div class="wu-th-title">'+thname+'</div></div>';
      $(thsample).appendTo($('.wu-bling-thumbs'));
      var tx = i*(110+space);
      var ty = 0;
      $('.wu-bling-thumbs .wu-pat-th-sl:eq('+i+')').css({'left':tx,'top':ty});
      $('.wu-bling-thumbs .wu-pat-th-sl:eq('+i+')').bind('click',onBlingSelect);

  	};
  
    if(currbling_style>2 && currbling_style!=9){
        var topage = Math.floor(currbling_style/3)-1;
        currblingstylepage += topage;
        navigateToBlingStylePage('right');
    }
  
}

function onBlingSelect() {
    
    //$('#wu-bling-img').show();

	$('.wu-bling-thumbs .wu-pat-th-sl').removeClass('selected');
    $(this).addClass('selected');
    currbling_style = Number($(this).attr('bstyle'));
  
   //$('#wu-bling-img').css('background-image', 'url('+ass_url+'wu-bling'+(currbling_style+1)+'.png)')
  
    
}

function setBlingStyle() {
  
    var bs = Number($(this).attr('bstyle'));
    blingstyle = bs;
    
    $('.blingcheck .wu-check-box-turq').removeClass('selected');
  	$(this).find('.wu-check-box-turq').addClass('selected');
    
  	calculatePrice();
}


// neck style

function addNeckStyles() {

	var pagecount = Math.floor(styles.length/3);
	maxneckpage = pagecount==styles.length/3?pagecount-1:pagecount;
  
    $('.wu-page-count-sl.neckstyles').text((currneckpage+1)+'/'+(maxneckpage+1));
    $('.wu-page-count-sl.neckstyles, .wu-pat-nav-neck *').hide();
  
  	if(styles.length>3){
      $('.wu-pat-nav-neck .right').show();
      $('.wu-page-count-sl.neckstyles').show();
    }
  
  	$(styles).each(function(index, element) {

      var thname = styles[index].toLowerCase().replace(/[^A-Za-z0-9]/, '');
      var thurl = ass_url+ 'wu-th-neck-'+ thname +'.png?123';
      var thsample = '<div class="wu-pat-th-sl" nstyle="'+index+'"><img src="'+thurl+'" /><div class="wu-th-title">'+style_names[index]+'</div></div>';
      $(thsample).appendTo($('.wu-neck-thumbs'));
      var tx = index*(110+space);
      var ty = 0;
      $('.wu-neck-thumbs .wu-pat-th-sl:eq('+index+')').css({'left':tx,'top':ty});
      $('.wu-neck-thumbs .wu-pat-th-sl:eq('+index+')').bind('click',onStyleSelect);

      if (is_new[index]==1){
        //var thnew = '<img style="height:22px; width:45px; margin-top:35px;" src="//cdn.shopify.com/s/files/1/0416/3169/t/12/assets/new.png?10031523512302373051" />';
        //$(thnew).appendTo($('.wu-pat-thumbs .wu-pat-th:eq('+index+')'))
      }
  	});
  
  	$('.wu-neck-thumbs .wu-pat-th-sl').eq(currstyle).click();

    if(currstyle>2){
        var topage = Math.floor(currstyle/3)-1;
        currneckpage += topage;
        navigateToNeckPage('right');
    }
}

/****************************************/
/********* thumb functions **************/
/****************************************/

function addThumbs(){
	var pagecount = Math.floor(singlets.length/6)
	maxthumbpage = pagecount==singlets.length/6?pagecount-1:pagecount
		
  $('.wu-page-count-sl.patterns').hide();
	$('.wu-page-count-sl.patterns').text((curthumbpage+1)+'/'+(maxthumbpage+1));

	if(singlets.length>6){
    $('.wu-page-count-sl.patterns').show();
		$('.wu-pat-nav-sl .right').show();
	}

	$(singlets).each(function(index, element) {

    var thname = singlets[index].toLowerCase().replace(/É|é/, 'e');
    thname = thname.replace(/[^A-Za-z0-9]/, '');
      
		var thurl = ass_url+ 'wu-th-sl-'+ thname +'.png?123';
    var thsample = '<div class="wu-pat-th-sl"><div class="wu-th-title-ls">'+singlets[index].toUpperCase()+'</div><img src="'+thurl+'" /></div>';
		$(thsample).appendTo($('.wu-pat-thumbs'));

    var rows = 2;

		var tx = (Math.floor(index/rows))*(110+space);
		var ty = index*(157+space-13) - Math.floor(index/rows)*(157+space-13)*rows;
		$('.wu-pat-thumbs .wu-pat-th-sl:eq('+index+')').css({'left':tx,'top':ty});
		$('.wu-pat-thumbs .wu-pat-th-sl:eq('+index+')').bind('click',thumbClick);

		if (is_new[index]==1){
			//var thnew = '<img style="height:22px; width:45px; margin-top:35px;" src="//cdn.shopify.com/s/files/1/0416/3169/t/12/assets/new.png?10031523512302373051" />';
			//$(thnew).appendTo($('.wu-pat-thumbs .wu-pat-th:eq('+index+')'))
		}
  });
    
  $('.empty-neck-style').clone(true).css('left', singlets.length*(110+space)-20).insertAfter('.empty-neck-style:first')

	loadDesign(currdesign);
	if(currdesign>5){
      	let topage = Math.floor(currdesign/6)-1;
      	curthumbpage += topage;
		navigateToPage('right');;
	}
}

function thumbClick(){
	let id = $(this).index();
	loadDesign(id);
}

function loadDesign(id){
    let dname = singlets[id].toLowerCase().replace(/É|é/, 'e');
    dname = dname.replace(/[^A-Za-z0-9]/, '');
	$('#wu-design').find('*[id*="design"]').css('display','none');
	let cdesign = $(document).find('*[id*="'+dname+'"]');
	$(cdesign).css('display','inline');
	$('.wu-pat-thumbs .wu-th-title-ls').removeClass('selected');
	$('.wu-pat-thumbs .wu-th-title-ls:eq('+id+')').addClass('selected');
	currdesign = id;

    $('.wu-design-title').text(dname);
	$('#svg-file').val(encodeURIComponent($('#wu-design').html()));

    $('#wu-dsg-title *').text(dname);
    setColorCount(dname);
}

function thNavClick(){
	navigateToPage($(this).attr('dir'));
}

function navigateToPage(dir){

	if(dir=='right'){
		$('.wu-pat-nav-sl .wu-pat-nav-btn.left').show();
		curthumbpage++;
		if(curthumbpage>maxthumbpage-1){
			$('.wu-pat-nav-sl .wu-pat-nav-btn.right').hide();
		}
	}else{
		$('.wu-pat-nav-sl .wu-pat-nav-btn.right').show();
		curthumbpage--;
		if(curthumbpage==0){
			$('.wu-pat-nav-sl .wu-pat-nav-btn.left').hide();
		}
	}
	$('.wu-pat-thumbs').animate({left:-curthumbpage*(110+space)*3},{duration:400,

	   /********* remove flickering ***********/
		step:function(){
			//$('#thumbs').hide();
			//$('#thumbs').show(.0001);
		}
	})

	$('.wu-page-count-sl.patterns').text((curthumbpage+1)+'/'+(maxthumbpage+1));
}


function blingNavClick() {
	navigateToBlingPage(($(this).attr('dir')));
}

let emb_titles = [
  {name:'Choose your bling:', id:0},
  {name:'Choose your team branding:', id:1},
]

function navigateToBlingPage(dir) {

	if(dir=='right'){
		$('.wu-pat-nav-bling .wu-pat-nav-btn.left').show();
		currblingpage++;
		if(currblingpage>maxblingpage-1){
			$('.wu-pat-nav-bling .wu-pat-nav-btn.right').hide();
		}
	}else{
		$('.wu-pat-nav-bling .wu-pat-nav-btn.right').show();
		currblingpage--;
		if(currblingpage==0){
			$('.wu-pat-nav-bling .wu-pat-nav-btn.left').hide();
		}
	}

  $('.nav-emb-title').text(emb_titles[currblingpage].name);
  
	$('.wu-emb-page-pages').animate({left:-currblingpage*414},{duration:400,

	   /********* remove flickering ***********/
		step:function(){
			//$('#thumbs').hide();
			//$('#thumbs').show(.0001);
		}                                                     
                                                                     
	})
}

function blingNavStyleClick() {
	navigateToBlingStylePage(($(this).attr('dir')));
}


function navigateToBlingStylePage(dir) {

	if(dir=='right'){
		$('.wu-pat-nav-bling .wu-pat-nav-btn.left').show();
		currblingstylepage++;
		if(currblingstylepage>maxblingstylepage-1){
			$('.wu-pat-nav-bling .wu-pat-nav-btn.right').hide();
		}
	}else{
		$('.wu-pat-nav-bling .wu-pat-nav-btn.right').show();
		currblingstylepage--;
		if(currblingstylepage==0){
			$('.wu-pat-nav-bling .wu-pat-nav-btn.left').hide();
		}
	}
  
	$('.wu-emb-page-pages').animate({left:-currblingstylepage*(110+space)*3},{duration:400,

	   /********* remove flickering ***********/
		step:function(){
			//$('#thumbs').hide();
			//$('#thumbs').show(.0001);
		}                                                     
                                                                     
	})
}


function neckNavClick() {
	navigateToNeckPage($(this).attr('dir'));

}

function navigateToNeckPage(dir){

	if(dir=='right'){
		$('.wu-pat-nav-neck .wu-pat-nav-btn.left').show();
		currneckpage++;
		if(currneckpage>maxneckpage-1){
			$('.wu-pat-nav-neck .wu-pat-nav-btn.right').hide();
		}
	}else{
		$('.wu-pat-nav-neck .wu-pat-nav-btn.right').show();
		currneckpage--;
		if(currneckpage==0){
			$('.wu-pat-nav-neck .wu-pat-nav-btn.left').hide();
		}
	}
  
	$('.wu-neck-thumbs').animate({left:-currneckpage*(110+space)*3},{duration:400,

	   /********* remove flickering ***********/
		step:function(){
			//$('#thumbs').hide();
			//$('#thumbs').show(.0001);
		},
                                                                     
        complete:function(){
          
          
          $('.wu-neck-thumbs .wu-pat-th-sl').animate({deg: 0},{
    
            duration:100,
            easing: "swing",
            step: function(now) {
                     $(this).css({ transform: 'rotate(' + now + 'deg)' });
                }
            })

		}                                                         
                                                                     
	})
    
    // animate each style thumb
    
  var trot = dir=='right'?-10:10;
    
  $('.wu-neck-thumbs .wu-pat-th-sl').animate({deg: trot},{
    
    duration:100,
    easing: "swing",
    step: function(now) {
       		 $(this).css({ transform: 'rotate(' + now + 'deg)' });
		}
  	})

	$('.wu-page-count-sl.neckstyles').text((currneckpage+1)+'/'+(maxneckpage+1));
}


/****************************************/
/********* color functions **************/
/****************************************/

function addStockColors(){


	$(scolors).each(function(index, element) {
		var cname = element.split('#')[0].toUpperCase();
		var cval = '#'+element.split('#')[1];

    var csample = '<div class="swatch tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>';
    $(csample).appendTo($('#wu-stock'));
    $('#wu-stock .swatch:eq('+index+')').css({'background-color':cval});

    var lsample = '<div class="swatch logo tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>';
		$(lsample).appendTo($('#wu-stock-logo'));
    $('#wu-stock-logo .swatch:eq('+index+')').css({'background-color':cval});

  });
  

  $(bindcolors).each(function(index, element) {
		var cname = element.split('#')[0].toUpperCase();
		var cval = '#'+element.split('#')[1];
    	var csample = '<div class="swatch zip tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>';
		$(csample).appendTo($('#wu-stock-zip-ls'));
		$('#wu-stock-zip-ls .swatch:eq('+index+')').css({'background-color':cval});
  });
  
  $(meshcolors).each(function(index, element) {
		var cname = element.split('#')[0].toUpperCase();
		var cval = '#'+element.split('#')[1];
    	var csample = '<div class="swatch tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>';
		$(csample).appendTo($('#wu-stock-mesh'));
		$('#wu-stock-mesh .swatch:eq('+index+')').css({'background-color':cval});
  });

  $('.wu-app-container .swatch').bind('click',swatchClick);
  //$('.tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150,distance:3});
}


function onMeshSelect() {
  
	currmesh = Number($(this).attr('sbind'));
    $('.meshcheck .wu-check-box-turq').removeClass('selected');
    $(this).find('.wu-check-box-turq').addClass('selected');
  
    if(currmesh==0) {
      $('[id*="meshes"]').hide();
    } else {
      $('[id*="meshes"]').show();
      var _mesh = $('[id="meshes"] [id*="'+styles[currstyle]+currmesh+'"]').not('pattern').attr('d');
      $('[id="meshclip"]').attr('d', _mesh)
    }

}



function onStyleSelect() {
   
  	$('.wu-neck-thumbs .wu-pat-th-sl').removeClass('selected');
    $(this).addClass('selected');
  	currstyle = Number($(this).attr('nstyle'));
  	setBindingStyle();

  
    //$('#wu-dsg-title *').text(style_names[currstyle]);
  	$('.binding-check').show();
  
    // if(currstyle==5) {
    //   $('.binding-check').hide();
    // }
  
   // set back yoke logo position
  
  	// if(currstyle==0 || currstyle==1 || currstyle==3) {
            
    //   $('#col5_logo3').css({
    //     'transform': 'translate(0px, 22px)',
    //     '-webkit-transform': 'translate(0px, 22px)',
    //     '-moz-transform': 'translate(0px, 22px)',
    //     '-ms-transform': 'translate(0px, 22px)',
    //     '-o-transform': 'translate(0px, 22px)'

    //   })

    // } else {

    //   $('#col5_logo3').css({
    //     'transform': 'translate(0px, 30px)',
    //     '-webkit-transform': 'translate(0px, 30px)',
    //     '-moz-transform': 'translate(0px, 30px)',
    //     '-ms-transform': 'translate(0px, 30px)',
    //     '-o-transform': 'translate(0px, 30px)'
    //   })

    // }
  
  
   
    // hide mesh if not needed
  
    // if(currstyle!=0 && currstyle!=1 && currstyle!=3) {
    //   $('.wu-mesh-tab').hide();
    //   $('.meshcheck').eq(0).click();
      
    // } else{
    //     $('.wu-mesh-tab').show();
    // 	$('.meshcheck').eq(currmesh).click();
    // }
    
}


function setBindingStyle() {
  

  $('[id*="bindings"] [id*="bind"]').hide();
  $('[id*="bindings"] [id*="'+styles[currstyle]+'"]').show();

  
  if(showbind==1 && currstyle==5) {
    $('.bindcheck:first').click();

  }
  
  $('[id*="diamline"]').hide()
  if(currcut==2) {
  	$('[id*="diamline"]').show()
  }
  
  setLeoClip();

}



function onCutSelect() {
    $('.stylecut').removeClass('selected');
  	$(this).addClass('selected');
  	currcut = Number($(this).attr('cstyle'));
  	setBindingStyle();
}



function setBinding() {
  
  $('.bindcheck .wu-check-box-turq').removeClass('selected');
  $(this).find('.wu-check-box-turq').addClass('selected');
  showbind = $(this).attr('sbind');
  
  
  if(showbind==1) {
    $('#wu-design-bindings [id*="bindings"]').hide();
  } else {
    $('#wu-design-bindings [id*="bindings"]').show();
  }
  
}

function setLeoClip() {
  var clip_path = $('[id*="patclips"] [id*="'+styles[currstyle]+currcut+'"]').attr('d');
  $('[id="desclip"]').attr('d',clip_path);
  
  
  var clip_url = ass_url+styles[currstyle]+currcut+'.svg'
  $('.wu-masked.top-mask-sl').css({
    'mask': 'url('+clip_url+')',
	'-webkit-mask': 'url('+clip_url+')',
    '-moz-mask': 'url('+clip_url+')',
  	'-ms-mask': 'url('+clip_url+')',
    '-o-mask': 'url('+clip_url+')',
    'mask-size': 'cover',
    '-webkit-mask-size': 'cover',
    '-moz-mask-size': 'cover',
    '-ms-mask-size': 'cover',
    '-o-mask-size': 'cover'
  })
  
}


function setMesh() {
	$('[id*="mesh"]').show()
}


// color tabs

function colTabClick(){
	setColTab($(this));
}

function setColTab(ctab){


  var col_cont = $(ctab).parent().find('.wu-tab-content.col-cont')
  currcoltab = Number($(ctab).attr('ctab'));

  var colselected

  colselected = currcolors[currcoltab];

  if(currcoltab==6) {
    range.noUiSlider.set(grad_color[2]/100);
    $('.wu-grad-remove .wu-check-box-turq').removeClass('selected');
    if(hasgrad==0) {
      $('.wu-grad-remove .wu-check-box-turq').addClass('selected');
    }
  }

 
  // check if bi ding or mesh
	if(currcoltab!=7 && currcoltab!=8){
		  $('.wu-color-tab').appendTo(col_cont);
    	picker.setColor('#'+colselected);

      // if gradient applied
      if(colselected.indexOf('.')!=-1) {
        var cval = colselected.split('.')[0];
        picker.setColor('#'+cval);
      }

	}else{
      setColor('col'+(currcoltab+1),'#'+colselected);
	}

	$('.wu-tab-content.col-cont').removeClass('focus').hide();
	col_cont.addClass('focus');
  $('.wu-tab-content.col-cont.focus').slideDown();

}

// logo tabs

function logTabClick(){
	//setLogTab($(this));
}

function setLogTab(ctab){

  let log_cont = $(ctab).parent().find('.wu-tab-content.log-cont');
  currcoltab = Number($(ctab).attr('ctab'));


  $('.wu-logo-tab, .wu-slide-holder, .wu-logsel-holder').appendTo(log_cont);
  $('.wu-tab-content.log-cont').removeClass('focus');
  
  // show hide colors
  if(currcoltab) {
    colselected = currcolors[currcoltab];
    $('.wu-logo-tab .wu-stock-holder').show();
    highlightSwatch('col'+(currcoltab+1), '#'+colselected);
  } else {
    $('.wu-logo-tab .wu-stock-holder').hide();
  }

  // set manipulated object
  var mid = Number($(ctab).attr('mtab'))

  if(obj_tgt[mid]) {
    setManuTarget(mid);
  }

  // show hide font selector
  if($(ctab).hasClass('tname')) {
    setTeamFont(font_id);
    $('.wu-team-input').val(team_name);
    setTeamName(team_name);
  } else {
  }


  // show hide logo selectors
  $('.erin-logos').hide();

  if($(ctab).hasClass('logsel')) {
    $('.wu-logsel-holder').show();
  } else {
    $('.wu-logsel-holder').hide();
  }

  if($(ctab).hasClass('top-logos')) $('.top-logos').show();


  $('.wu-tab-content.log-cont').removeClass('focus').hide();
	log_cont.addClass('focus');
  $('.wu-tab-content.log-cont.focus').slideDown();

}


function swatchClick(){


	var swcolor = $(this).css('background-color');
    highlightNewSwatch(swcolor);
	/**** if swatch empty do not chnage color *****/

     // if ombre

    if(currcoltab==6){
      $('#wu-colors').hide();
      $('#wu-grad-color').css('background',swcolor);
    }

    //  if not binding or mesh

    if(currcoltab!=7 && currcoltab!=9){

        picker.setColor(RGBtoHEX(swcolor));

    } else {

        var hex = RGBtoHEX(swcolor);
        currcolors[currcoltab] = hex.split('#')[1];
        setColor('col'+(currcoltab+1),swcolor);

    }

}

function gradientOnColorSelect() {
	if(hasgrad==0) {
    	checkGradient()
    }
}

function setColorByPicker(){
  var pcolor = picker.color;

   currcolors[currcoltab] = pcolor.split('#')[1];


  if(currcoltab==6)  {
    currcolors[currcoltab] = pcolor.split('#')[1];
    grad_color[0] = pcolor;
    grad_color[1] = hexToRgbA(pcolor)
    setGradientColor();
   
  } else {
    setColor('col'+(currcoltab+1),pcolor);
  }


   $('#wu-colsamp').css('background-color',pcolor);
   $('#wu-color').text(pcolor);
}


function setColor(part,value){

    let cpart

    cpart = $(document).find('*[id*="'+part+'"]');

    // exlude cliping paths
    $(cpart).find('*').not('[fill*="url"]').attr('fill',value);

    if(cpart!=undefined && cpart.length>0) {
      cpart.each(function(k, cpart_val) {

        let ccpart = $(cpart_val);
 
        let coltype = ccpart.attr('id').indexOf('grad');
        
        if(coltype!=-1) {
  
           let att_split = ccpart.attr('id').split('grad');
  
          //if multicolorgradient and containd 'grad' 2 times in ID
          
          if(att_split.length>2) {
  
            let grad_cols = att_split[1].split('');
            
            ccpart.find('*').each(function(j, val) {
  
               let furl = $(val).attr('fill');
               furl = furl.replace('url(','').replace(')','');
               let gradurl = $(furl).attr('xlink:href');

                grad_cols.forEach(function(e, i) {
                    $(gradurl).find('stop').eq(i).attr('stop-color','#'+currcolors[e-1]);
                })
            })
            
          } else {
            ccpart.find('*').each(function(i, e) {
              let furl = $(e).attr('fill');
              furl = furl.replace('url(','').replace(')','');
              $(furl).find('stop').attr('stop-color',value);
            })
            // fill gradient types
          }
        }
      })
    }

	$(cpart).attr('fill',value);
    
    if(part=="col6") {
      $('[id="col6"]').css('color', value);
    }
	$('#wu-colsamp').css('background-color',value);
    $('#wu-color').text(value);
  
    if(part=="col9") {
      $('[id="mspattern"] path').attr('fill', value)
    }
  
   //highlightSwatch(part,value);

}

function RGBtoHEX (color) {
  return "#"+$.map(color.match(/\b(\d+)\b/g),function(digit){
    return ('0' + parseInt(digit).toString(16)).slice(-2);
  }).join('');
}

function hexToRgbA(hex, opacity){
    var c;
  var op = opacity?opacity:0;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+op+')';
    }

}

function onColorInput(){
	var ival = $(this).val().split('#');
	var tval = ival.join('');
	$(this).val('#'+tval);
	picker.setColor($(this).val());
}



/****************************************/
/*************** logo functions *********/
/****************************************/

function onLogChooseClick(){
  currlogos = Number($(this).attr('lval'));
  setLogos();
}

function setLogos() {

  // 0-chest
  // 1-sleeve
  // 2-hip
  // 3-back yoke


  $('#wu-design [id*="logo"]').not('[id*="logos"]').hide();
  $('.top-logos .logochoose .wu-check-box-turq').removeClass('selected');
  $('.top-logos .logochoose .wu-check-box-turq').eq(currlogos).addClass('selected');


  $('#wu-design [id*="logo'+currlogos+'"]').show();


}




/********************************************/
/************ share functions ***************/
/********************************************/

function shareDesign(){

  	var imgtitle = "Check out this OZONE design I created!";

	var platform = $(this).attr('sharer');
	var share_url = getDesignUrl();
  
  var body_footer = "\n\nOzone Gymnastics Apparel™\nTel: +1-888-479-4011\nEmail: customerserviceweb@ozoneleos.com\n\n"
        body_footer += "The information in this e-mail and any attachment is confidential and is intended only for the named recipient(s). "
        body_footer += "The e-mail may not be disclosed or used by any person other than the addressee, nor may it be copied in any way. "
        body_footer += "If you are not a named recipient please notify the sender immediately and delete any copies of this message. "
        body_footer += "Any unauthorised copying, disclosure or distribution of the material  in this e-mail is strictly forbidden. "
        body_footer += "Any view or opinions presented are solely those of the author and do not necessarily represent those of Ozone Gymnastics Apparel™.";
    	
  var body_content = "Check out our brand new uniform:\n"+share_url+body_footer;
  
	switch(platform){


		case 'fb':
			window.open("https://www.facebook.com/sharer/sharer.php?p[url]="+escape(share_url)+"&p[title]="+imgtitle , '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
		 break;

		case 'tw':
			window.open('http://twitter.com/share?text='+imgtitle+'&url='+escape(share_url));
		 break;

		case 'embtn':

          
          var mate_emails =  $('.wu-mail').val();
          if(mate_emails!='' &&  mate_emails!=undefined) {
            window.open("mailto:"+mate_emails+"?Subject=" + encodeURIComponent(imgtitle) + "&body=" + encodeURIComponent(body_content))
          } else {
              alert('Email empty!');
          }
		
		break;
        
        case 'tmbtn':

          imgtitle = "Hey teammates, I've been busy designing some awesome new warm-ups for our team on OZONE's Design Studio. Check it out!";
          var mate_emails =  $('.wu-team-mail').val();
          if(mate_emails!='' &&  mate_emails!=undefined) {
            window.open("mailto:"+mate_emails+"?Subject=" + encodeURIComponent(imgtitle) + "&body=" + encodeURIComponent(body_content))
          } else {
              alert('Email empty!');
          }
		
		break;
	}

}


function getDesignUrl(){

    
	let  share_url = window.location.href + "/?design=";
    share_url =  share_url.indexOf('/?design=')==-1?share_url:share_url.split("/?design=")[0] + "/?design=";
    
    share_url += currdesign + '/'									                                                    // design id
    share_url += currstyle + '-' + currcut + '/'                                                                        // style and cut
      
    let color_data = currcolors.join('-')
	share_url += color_data +'/'									                                                    // color data
    share_url += hasgrad + '-' + gflip +'/'							                                                    // gradients and flipped						
    
    share_url += currlogos +'/'										                                                    // logos selected
    share_url += escape(team_name) + '/'							                                                    // team names
    share_url += font_id + '/'										                                                    // team fonts
    share_url += showbind + '-' + currbling + '-' + blingstyle + '-' + currmesh +'-' + skin_tone + '-' + currbling_style + '/'                // binding, bling, mesh, skin tone
    																	
    share_url += ctr_vals[0].join('_') + '_'						                                                    // logo and team name control values
    share_url += ctr_vals[1].join('_') + '_'
    share_url += ctr_vals[2].join('_') +  '_'
    share_url += ctr_vals_team[0].join('_')

	return share_url
}


// gradient picker

var grad_a = '#ffffff';
var grad_pct = 0;
var grad_color = ['#ffffff','rgba(255,255,255,0)',50];
var range = null;
var gflip = 1;

function initGradientPicker(){

  $('#wu-grad-color').click(function() {
    $('#wu-colors').show();
  })
  
  range = document.getElementById('grad-pct');
  
  var colsplit = currcolors[6].split('.')
  grad_color[0] = '#'+colsplit[0]
  grad_color[1] = hexToRgbA('#'+colsplit[0]);;
  grad_color[2] = colsplit[1]
  var top_val = grad_color[2]/100;


  noUiSlider.create(range, {
		start: top_val,
		margin: 0,
		connect: true,
		direction: 'ltr',
		orientation: 'vertical',
		behaviour: 'tap-drag',
		step: 0.01,
		tooltips: false,
		range: {
			'min': 0,
			'max': 1
		}
	});

	range.noUiSlider.on('update', function( values, handle ) {

		grad_pct = values[0]
		grad_color[2] = Math.floor(grad_pct*100)
		setGradientColor();
      
	})
  
    $('[ctab="6"]').click();     
    range.noUiSlider.set(grad_color[2]/100);
}

function checkGradient() {

  if(hasgrad==1) {
    hasgrad = 0;
  } else {
    hasgrad = 1;
  }
  addGradient();
}

function addGradient() {
  $('.wu-grad-remove .wu-check-box-turq').removeClass('selected');

  if(hasgrad == 1) {
    $('.wu-grad-remove .wu-check-box-turq').addClass('selected');
  }
  $(document).find('*[id*="col7"]').hide();
  if(hasgrad==1) $(document).find('[id*="col7"]').show();
 
}

function gradFlip() {
  if(gflip==0) {
    gflip=1;
  } else {
    gflip=0;
  }
  setGradientColor();
}


function setGradientColor(){

    var grad = '#body-gradient'
    
    if(gflip==1) {
      
      	var scolor = hexToRgbA(grad_color[0], (100-grad_color[2])/100);
        	    
      	$(grad+' stop:eq(0)').attr('stop-color',grad_color[1]);
      	$(grad+' stop:eq(1)').attr('stop-color',scolor);
  	  	$(grad+' stop:eq(2)').attr('stop-color',grad_color[0]);
      	$(grad).find('stop').eq(0).attr('offset',0);
      	$(grad).find('stop').eq(1).attr('offset',(grad_color[2])/100);
      	$(grad).find('stop').eq(2).attr('offset',1);
      
    } else {
      
      	var scolor = hexToRgbA(grad_color[0], (grad_color[2])/100);
      
        $(grad+' stop:eq(0)').attr('stop-color',grad_color[0]);
      	$(grad+' stop:eq(1)').attr('stop-color',scolor);
  		$(grad+' stop:eq(2)').attr('stop-color',grad_color[1]);
  		$(grad).find('stop').eq(0).attr('offset',0);
      	$(grad).find('stop').eq(1).attr('offset',(grad_color[2])/100);
      	$(grad).find('stop').eq(2).attr('offset',1);
    }

    var cpart = $(document).find('[id*="col7"]');

	$(cpart).attr('fill','url('+grad+')');

  	currcoltab = 6;
	currcolors[currcoltab] = grad_color[0].split('#')[1] + '.' + grad_color[2];
  
   highlightSwatch('col'+(currcoltab+1), '#'+currcolors[currcoltab]);

}


function highlightSwatch (part, value) {
	
	var sel_col;
	var all_cols;
	var sel_tgt;
  
  if (value.indexOf('.')!=-1) {
  	value = value.split('.')[0]
  }
  
  if (value.indexOf('#')==-1) {
  	value = RGBtoHEX(value)
  }

	value = value.toLowerCase();
	
	switch (part) {
		
		case 'col5':
		all_cols = scolors;
		sel_tgt = '#wu-stock-logo';
		break;
			
		case 'col6':
		all_cols = scolors;
		sel_tgt = '#wu-stock-logo';
		break;
		
		case 'col8':
		all_cols = bindcolors;
		sel_tgt = '#wu-stock-zip-ls';
		break;
		
		case 'col9':
		all_cols = meshcolors;
		sel_tgt = '#wu-stock-mesh';
		break;
		
		default:
		all_cols = scolors;
		sel_tgt = '#wu-stock';
		
	}	
	
	$(sel_tgt + ' .sw-selected').remove();
	
	
	sel_col = all_cols.filter(function(e) {			
		return '#'+e.split('#')[1].toLowerCase() === value;			
	})[0]
	
	if(sel_col!=undefined) {
		var col_name = sel_col.split('#')[0];	
		var col_swatch = $(sel_tgt + ' .swatch').filter(function() {
			return $(this).attr('title') === col_name;
		})[0];
		
		if(col_swatch!=undefined) {
							
			var sw_selected = $('<div class="sw-selected">O</div>');
			$(sw_selected).css({
				'position': 'absolute',
				'left': '0px',
				'top': '0px',
				'width': '100%',
				'height': '100%',
				'color': 'white',
				'text-align': 'center',
				'line-height': '26px',
				'font-weight': 'bold',
				'text-shadow': '0px 0px 2px rgba(0,0,0,0.9)',
				'font-family': 'Phosphate'
			})
			$(col_swatch).css('position', 'relative').append(sw_selected);
						
		}
	}
}


//$('#svg-file').val(encodeURIComponent($('#design').html()))

/*
<defs id="grad-def">
  <linearGradient id="body-gradient" x1="0.5" y1="0" x2="0.5" y2="1">
   <stop offset="0" stop-color="#ff0000" />
   <stop offset="0.5" stop-color="#ccff00" />
   <stop offset="1" stop-color="#ccff00" />
  </linearGradient>

  
  <filter id="col2-flt" x="0" y="0" width="100%" height="100%">
  	<feColorMatrix type="matrix" values="1.00 0 0 0 0 0 0.94 0 0 0 0 0 0.00 0 0 0 0 0 1 0" />
  </filter>
  <filter id="co3-flt" x="0" y="0" width="100%" height="100%">
  	<feColorMatrix type="matrix" values="1.00 0 0 0 0 0 0.94 0 0 0 0 0 0.00 0 0 0 0 0 1 0" />
  </filter>
  <filter id="col4-flt" x="0" y="0" width="100%" height="100%">
  	<feColorMatrix type="matrix" values="1.00 0 0 0 0 0 0.94 0 0 0 0 0 0.00 0 0 0 0 0 1 0" />
  </filter>
  
</defs>
*/


/// hide curerdnt color tabs



/// hide curerdnt color tabs

$('.wu-tabs').hide();

//////////////////////////////////
// color selection naviagation

let col_pages = [
  // {name:'A', id:0},
  // {name:'B', id:1},
  // {name:'C', id:2},
  // {name:'D', id:3},
  // {name:'Ozone Logo', id:4},
]

let curcolpage=0, maxcolpage=col_pages.length-1;

function setColorCount(dname) {
  
    // display colour tabs according to design colours count
  
    col_pages = [];
    let colcount = 1;
    let colnames = ['A','B','C','D','E','F','G']
    let col_obj= {name:'A', id:0};

    col_pages.push(col_obj);

    // start adding from 2nd color

    for(i=1; i<colnames.length;i++) {

      if($(document).find('[id*="'+dname+'"]').find('[id*="col'+(i+1)+'"]').length!=0) {
        col_obj= {name:colnames[i], id:i};
        col_pages.push(col_obj);
      }
    }

    col_pages.push({name:'OZONE Logo', id:4});
    col_pages.push({name:'Team Name', id:5});
    col_pages.push({name:'Add Ombre', id:6});

    currcoltab = 0;
    highlightNewSwatch('#'+initcolors[0]);

    curcolpage=0, maxcolpage=col_pages.length-1;
    $('.nav-color-title').text('Choose '+col_pages[curcolpage].name + ' Color:');
    $('.wu-pat-nav-color .wu-pat-nav-btn.left').hide();
    $('.wu-pat-nav-color .wu-pat-nav-btn.right').show();
    
}

function thColClick() {
  navigateToColPage($(this).attr('dir'));
}

function navigateToColPage(dir) {

  $('#wu-colors').show();

  if(dir=='right'){
    
		$('.wu-pat-nav-color .wu-pat-nav-btn.left').show();
		curcolpage++;
 
		if(curcolpage==maxcolpage){
			$('.wu-pat-nav-color .wu-pat-nav-btn.right').hide();
            $('#wu-colors').hide();
		}
    
	}else{
    
		$('.wu-pat-nav-color .wu-pat-nav-btn.right').show();
		curcolpage--;
		if(curcolpage==0){
			$('.wu-pat-nav-color .wu-pat-nav-btn.left').hide();
		}
	}


  currcoltab = col_pages[curcolpage].id;
  colselected = currcolors[currcoltab];


  if(col_pages[curcolpage].name.indexOf('Ombre')==-1) {
     $('.nav-color-title').text('Choose '+col_pages[curcolpage].name + ' Color:');
  } else {
     $('.nav-color-title').text(col_pages[curcolpage].name);
  }

    // show ombre 
    $('#wu-ombre-cont').hide();
      
    if(curcolpage==maxcolpage) {
      $('#wu-colors').hide();
      $('#wu-ombre-cont').show();
      colselected = currcolors[currcoltab].split('.')[0];
      $('#wu-grad-color').css('background','#'+colselected);

      addGradient();
      range.noUiSlider.set(grad_color[2]/100);
      
    } 
  
    highlightNewSwatch('#'+colselected);

}


//////////////////////////////////

//////////////////////////////////
// embellish seelction navigation

let emb_pages = [
  {name:'Standard', id:0},
  {name:'Holographic', id:1},
  {name:'Glossy', id:2}
]

let curblpage=0, maxblpage=emb_pages.length-1;

function thEmbClick() {
  navigateToEmbPage($(this).attr('dir'));
}

function navigateToEmbPage(dir) {
  if(dir=='right'){
		$('.wu-pat-nav-emb .wu-pat-nav-btn.left').show();
		curblpage++;
		if(curblpage>maxblpage-1){
			$('.wu-pat-nav-emb .wu-pat-nav-btn.right').hide();
		}
	}else{
		$('.wu-pat-nav-emb .wu-pat-nav-btn.right').show();
		curblpage--;
		if(curblpage==0){
			$('.wu-pat-nav-emb .wu-pat-nav-btn.left').hide();
		}
	}

  $('.wu-bling-thumb-slider').animate({left:-emb_pages[curblpage].id*391},500);

  $('.nav-bling-title').text('Choose Bling Color '+emb_pages[curblpage].name + ':');

}

// new colors

let sscolors = [
    "APE#fabeaf",
    "APL#b7d435",
    "ARB#8ed6e8",
    "BAL#efe2e6",
    "BL1#005897",
    "BLK#000000",
    "BP1#e70e8a",
    "BRG#fcb116",
    "BRN#300c00",
    "BUH#fcd3cb",
    "CAL#009f93",
    "CAR#5f0017",
    "CBT#008cd1",
    "CEX#02b292",
    "CHG#1d2329",
    "COL#6599c2",
    "COR#f48588",
    "CRL#f7a39b",
    "CRT#00a89b",
    "CTE#00576d",
    "CTN#f6a9cb",
    "DEB#112e32",
    "DKG#002700",
    "DKM#35020f",
    "DP1#232153",
    "DRK#552a13",
    "DUB#7d8896",
    "FCI#f58132",
    "FER#ab151b",
    "FRR#e04867",
    "FUS#6b136a",
    "GL1#d7ad56",
    "GNT#d0dcc1",
    "GR1#26b67e",
    "GRP#7265ad",
    "GRY#aba09a",
    "HGR#d2de26",
    "HIB#9d316b",
    "HPK#f05377",
    "ICM#addedf",
    "ICR#7b1721",
    "IRS#1b65b0",
    "JGR#364f25",
    "KEL#00823f",
    "LAV#bbb4d9",
    "LEM#ffe500",
    "LG1#89c64f",
    "LGT#f0d0ac",
    "LIM#bfd730",
    "LMD#fff9ae",
    "LPK#fcd8de",
    "MAG#ac004f",
    "MAR#540011",
    "MAU#82c2cb",
    "MBZ#a3621e",
    "MDA#7c421d",
    "MDG#00513f",
    "MED#c8a772",
    "MID#383461",
    "MLB#ab5965",
    "MLG#d2b08f",
    "MNT#8bd0c1",
    "MRN#2ebba8",
    "NOR#f36e51",
    "NPK#f05d9a",
    "NTL#008a68",
    "NVY#00002f",
    "NYL#fff200",
    "OCE#00b0e7",
    "ODP#0d0149",
    "OLD#9e6331",
    "OMH#c50876",
    "ORC#5354a4",
    "ORD#79121c",
    "ORG#c53d21",
    "OWN#48153d",
    "PAC#e98f81",
    "PAP#f3735e",
    "PAS#d7ecf7",
    "PB1#00b0d7",
    "PBL#0090a8",
    "PCO#b7d2bc",
    "PEO#e6126a",
    "PET#e5c1b2",
    "PGT#6c3742",
    "PKL#cd94c2",
    "PKS#c29684",
    "PPU#f16276",
    "PRW#475894",
    "PU1#7e3996",
    "PUR#343680",
    "PWB#9cd8f1",
    "RAS#631361",
    "RE1#e1222e",
    "RED#a11527",
    "RNT#00ab96",
    "ROE#80cecc",
    "ROY#003068",
    "SAG#768c84",
    "SB2#00589d",
    "SCR#b21a2f",
    "SKA#85769e",
    "SKB#8fb0d8",
    "SLA#45423f",
    "SML#75b0bb",
    "SPG#44415d",
    "SPT#89c5a7",
    "SRP#ea9377",
    "STG#9ea3a7",
    "SWP#ef509c",
    "TAO#f68b1f",
    "TER#f47b36",
    "TNO#d4742f",
    "TRT#0db9b9",
    "TXO#893223",
    "UMN#83c28e",
    "VGD#d5b785",
    "VIO#3e3971",
    "WAT#f1585e",
    "WBR#a554a1",
    "WHE#a18a66",
    "WHT#ffffff",
    "CAB#1e3182"
]

  function highlightNewSwatch (value) {
	
    var sel_col;
    var all_cols;
    var sel_tgt;
    
    if (value.indexOf('.')!=-1) {
      value = value.split('.')[0]
    }
    
    if (value.indexOf('#')==-1) {
      value = RGBtoHEX(value)
    }
    
    value = value.toLowerCase();

    all_cols = sscolors;
    sel_tgt = '#wu-colors';
    
    $('.sw-selected').remove();
    
    sel_col = all_cols.filter(function(e) {			
      return '#'+e.split('#')[1].toLowerCase() === value;			
    })[0]

    
    if(sel_col!=undefined) {
      var col_name = sel_col.split('#')[0];	
      var col_swatch = $(sel_tgt + ' .nswatch').filter(function() {
        return $(this).attr('title') === col_name;
      })[0];
      
      if(col_swatch!=undefined) {
                
        var sw_selected = $('<div class="sw-selected">O</div>');
        $(sw_selected).css({
          'position': 'absolute',
          'left': '0px',
          'top': '1px',
          'width': '100%',
          'height': '100%',
          'color': 'white',
          'text-align': 'center',
          'line-height': '26px',
          'font-weight': 'bold',
          'text-shadow': '0px 0px 2px rgba(0,0,0,0.9)',
          'font-family': 'Phosphate'
        })
        $(col_swatch).css('position', 'relative').append(sw_selected);
              
      }
    }
  }

// add new color swatches and bling thumbs
$(document).ready(function() {

  $(sscolors).each(function(index, element) {

    if(element!='%%#') {
      var cname = element.split('#')[0]
      var cval = '#'+element.split('#')[1];

      var csample = '<div class="nswatch-cont"><div class="nswatch" title="'+cname+'" style="background-color:'+cval+'"></div><div class="nswatch-title">'+cname+'</div></div>';
      $(csample).appendTo($('#wu-colors'));
      $('#wu-colors .nswatch:eq('+index+')').css({'background-color':cval});

    } else {
      $('#wu-colors').append('<div class="wu-col-sep"></div>');
    }

  });

  $('#wu-colors .nswatch').click(swatchClick);
  highlightNewSwatch('#'+initcolors[0])


  let blingnames = [
    ['Clear','Metallic White','Black','Pink','Hot Pink','Scarlet','Purple','Kelly Green','Jade','Columbia','Royal','Metallic Gold','Orange'],
    ['HBK','HNO','HCO','HON','HGC','HPU','HGO','HRO','HHG','HSP','HHP','HSC','HJD','HSI','HKE','HTQ','HPL','HWT'],
    ['BLK','ROY','BRG','SCR','EMR','SIL','GOL','TRQ','MNT','VIO','PUR','WHT','RBO']
  ];
  let blinghtumbs = ['wu-bl-st-','wu-bl-holo-','wu-bl-gloss-'];
  let bling_id=-1;
  
  blingnames.forEach(function(e, i) {

    let thname , thurl;
    e.forEach(function(n,j) {
      bling_id++;
      thurl = ass_url+blinghtumbs[i] + (j+1) + '.png';
      thname = n; // replace with real names after added
      let blthumb = $(`<div bid="${bling_id}" title="${thname}" class="wu-bl-thumb"><img src="${thurl}"><div class="wu-bl-title">${thname}</div></div>`);
      let tgt = $('.'+blinghtumbs[i]+'cont');
      tgt.append(blthumb);
    })

  })

  $('.wu-bl-thumb').on('click', function() {
    $('.wu-bl-thumb').removeClass('selected');
    $(this).addClass('selected');
    currbling = parseInt($(this).attr('bid'));
  })

})


// rteminder pop screen 
let remTimeout = null;
let remtriggered = false;

function stratRemTimeout() {
  remTimeout = setTimeout(showReminder,30000);
}

function showReminder() {
  remtriggered = true;
  $('.wu-reminder').fadeIn(700).on('click', function() {
    $('.wu-reminder').fadeOut(500);
  });
}
